<template>
  <div class="img-container">
    <div class="loadingio-spinner-double-ring-6p7qty8bf1c"><div class="ldio-0emdpniksfb">
      <div></div>
      <div></div>
      <div><div></div></div>
      <div><div></div></div>
    </div></div>
  </div>
</template>

<script>
  export default {
    name: "LoadingComponent"
  }
</script>


<style scoped>
  .img-container {
    position: fixed;
    top: 50%;
    left: 50%;

    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    /*background: rgba(255, 255, 255, 0.67);*/
  }

  @keyframes ldio-0emdpniksfb {
    0% { transform: rotate(0) }
    100% { transform: rotate(360deg) }
  }

  .ldio-0emdpniksfb div { box-sizing: border-box!important }
  .ldio-0emdpniksfb > div {
    position: absolute;
    width: 72px;
    height: 72px;
    top: 14px;
    left: 14px;
    border-radius: 50%;
    border: 8px solid #000;
    border-color: #e15b64 transparent #e15b64 transparent;
    animation: ldio-0emdpniksfb 1s linear infinite;
  }

  .ldio-0emdpniksfb > div:nth-child(2), .ldio-0emdpniksfb > div:nth-child(4) {
    width: 54px;
    height: 54px;
    top: 23px;
    left: 23px;
    animation: ldio-0emdpniksfb 1s linear infinite reverse;
  }
  .ldio-0emdpniksfb > div:nth-child(2) {
    border-color: transparent #f8b26a transparent #f8b26a
  }
  .ldio-0emdpniksfb > div:nth-child(3) { border-color: transparent }
  .ldio-0emdpniksfb > div:nth-child(3) div {
    position: absolute;
    width: 100%;
    height: 100%;
    transform: rotate(45deg);
  }
  .ldio-0emdpniksfb > div:nth-child(3) div:before, .ldio-0emdpniksfb > div:nth-child(3) div:after {
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 8px;
    top: -8px;
    left: 24px;
    background: #e15b64;
    border-radius: 50%;
    box-shadow: 0 64px 0 0 #e15b64;
  }
  .ldio-0emdpniksfb > div:nth-child(3) div:after {
    left: -8px;
    top: 24px;
    box-shadow: 64px 0 0 0 #e15b64;
  }

  .ldio-0emdpniksfb > div:nth-child(4) { border-color: transparent; }
  .ldio-0emdpniksfb > div:nth-child(4) div {
    position: absolute;
    width: 100%;
    height: 100%;
    transform: rotate(45deg);
  }
  .ldio-0emdpniksfb > div:nth-child(4) div:before, .ldio-0emdpniksfb > div:nth-child(4) div:after {
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 8px;
    top: -8px;
    left: 15px;
    background: #f8b26a;
    border-radius: 50%;
    box-shadow: 0 46px 0 0 #f8b26a;
  }
  .ldio-0emdpniksfb > div:nth-child(4) div:after {
    left: -8px;
    top: 15px;
    box-shadow: 46px 0 0 0 #f8b26a;
  }
  .loadingio-spinner-double-ring-6p7qty8bf1c {
    width: 58px;
    height: 58px;
    display: inline-block;
    overflow: hidden;
    background: rgba(255, 255, 255, 0);
  }
  .ldio-0emdpniksfb {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(0.58);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .ldio-0emdpniksfb div { box-sizing: content-box; }

</style>
